import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CourseService } from '../services/course.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.css']
})
export class ModalComponent {
  @Input() showModal: boolean = false;
  @Input() TopicCourseDetails: any;
  @Output() closed = new EventEmitter<boolean>();
  topicCourseModel: any;

  constructor(private readonly courseService: CourseService, private readonly toastr: ToastrService) {} 

  closeModal(){
    this.showModal = false
    this.closed.emit();
  }

  deleteTopicCourse() {
    let postObj = {
      "topicId": "",
      "courseId": ""
  };
  if(this.topicCourseModel == 'Topic') {
    postObj.topicId = this.TopicCourseDetails.topicID;
  } else {
    postObj.courseId = this.TopicCourseDetails.courseID;
  }
  const deleteTopicCourseObs =   this.courseService.deleteTopicCourse(postObj).subscribe({
      next: val => {
        this.toastr.success('The selected ' + this.topicCourseModel + ' was deleted successfully.', 'Success!');
        this.topicCourseModel = undefined;
        this.closed.emit(true);
      },
      error: err => { 
        this.toastr.success('There was error while deleting the ' + this.topicCourseModel + ' Please try after sometime.', 'Error!');
        this.topicCourseModel = undefined;
        this.closed.emit(false); 
      },
      complete: () => {
        deleteTopicCourseObs.unsubscribe();
      }
    })
  }
}
